import { type FunctionComponent } from "react";
import { useTranslation } from "react-i18next";

const sections = ["damageManagement", "maintenance", "vehicleReturn", "hotline"];

type Props = {
  titleHidden?: boolean;
};

type ContactRowProps = {
  label: string;
  href: string;
  title: string;
  linkClassName?: string;
};

const ContactRow = ({ label, href, title, linkClassName = "" }: ContactRowProps) => (
  <tr>
    <td className="w-[60px] text-sm md:text-base leading-6">{label}</td>
    <td>
      <a className={linkClassName} href={href}>
        {title}
      </a>
    </td>
  </tr>
);

export const ContactUs: FunctionComponent<Props> = ({ titleHidden = false }) => {
  const { t } = useTranslation();

  return (
    <div>
      <div
        className={`footerBlockHeadline text-2xl font-serif text-neutral-700 mb-3 ${
          titleHidden && "hidden md:block"
        }`}
      >
        {!titleHidden && t("contact.title")}&nbsp;
      </div>

      <table className="w-full mt-3">
        <tbody className="align-top">
          {sections.map((key) => (
            <div key={key} className="pb-6">
              <tr>
                <td colSpan={2} className="font-bold">
                  {t(`contact.raiffeisen.${key}.label`)}
                </td>
              </tr>
              <ContactRow
                label={t("contact.phone.label")}
                href={t(`contact.raiffeisen.${key}.phone.link`)}
                title={t(`contact.raiffeisen.${key}.phone.title`)}
                linkClassName="no-underline"
              />
              {t(`contact.raiffeisen.${key}.email.title`, { defaultValue: null }) && (
                <ContactRow
                  label={t("contact.email.label")}
                  href={t(`contact.raiffeisen.${key}.email.link`)}
                  title={t(`contact.raiffeisen.${key}.email.title`)}
                />
              )}
            </div>
          ))}
        </tbody>
      </table>
    </div>
  );
};
